var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "last-tickets-wrapper" },
    [
      _c("CircleLoader", { attrs: { loader: _vm.lastTicketsInProgress } }),
      _c("Actions", { attrs: { isMob: _vm.isMob } }),
      _c("Scrollable", [
        _c(
          "div",
          { staticClass: "last-tickets-body" },
          [
            !_vm.tickets.length
              ? _c("div", { staticClass: "no-tickets-message" }, [
                  _c("i", { staticClass: "icon icon-betslip" }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm._f("translate")("general_tickets_empty_info"))
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._l(_vm.tickets, function (ticket, key) {
              return _c("TicketItem", {
                key: key,
                attrs: { isMob: _vm.isMob, ticket: ticket },
              })
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }